import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { formatQueryParams } from "helpers/format";
import contentTypeApi from "api/contentTypeApi";

export const getContentTypeList = createAsyncThunk(
  "ContentType",
  async (params: any = {}) => {
    try {
      const response = await contentTypeApi.contents(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getContentTypeDetail =  async(id: string | number ,  params: any = {}) => {
  try{
    const response = await contentTypeApi.getContent(id)
    return response;
  }catch (error) {
    return error;
  }
};

export const postContentType = async (data: any = {}) => {
  try{
    const response = await contentTypeApi.postContent(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putContentType = async (id: string | number , data: any = {}) => {
  try{
    const response = await contentTypeApi.putContent(id, data);
    return response;
  }catch (error) {
    return error;
  }
};